import { render, staticRenderFns } from "./NewTodo.vue?vue&type=template&id=de600b70&scoped=true&lang=pug&"
import script from "./NewTodo.vue?vue&type=script&lang=js&"
export * from "./NewTodo.vue?vue&type=script&lang=js&"
import style0 from "./NewTodo.vue?vue&type=style&index=0&id=de600b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de600b70",
  null
  
)

component.options.__file = "NewTodo.vue"
export default component.exports